import { render, staticRenderFns } from "./BasicCheck.vue?vue&type=template&id=8bc50d86&scoped=true"
import script from "./BasicCheck.vue?vue&type=script&lang=js"
export * from "./BasicCheck.vue?vue&type=script&lang=js"
import style0 from "./BasicCheck.vue?vue&type=style&index=0&id=8bc50d86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc50d86",
  null
  
)

export default component.exports